import React, {useState} from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import {useCart} from "../context/CartContext";
import logoImg from "../assets/logo.png";
import "../assets/css/Header.css"; // We'll create this CSS file

export default function Header({title}) {
    const {items, totalQty, totalPrice, removeFromCart, changeQty, clearCart} = useCart();
    const [open, setOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const linkStyle = {
        padding: "6px 10px",
        borderRadius: 8,
        textDecoration: "none",
        fontWeight: 700,
        fontSize: 14,
        border: "1px solid transparent",
        whiteSpace: "nowrap"
    };
    const activeStyle = {...linkStyle, color: "#111", background: "#eef2ff", border: "1px solid #c7d2fe"};
    const idleStyle = {...linkStyle, color: "#475569"};
    const navigate = useNavigate();

    return (
        <>
            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)}>
                    <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
                        <div className="mobile-menu-header">
                            <span>منو</span>
                            <button className="text-btn" onClick={() => setMobileMenuOpen(false)}>✖</button>
                        </div>
                        <nav className="mobile-nav">
                            <NavLink 
                                to="/" 
                                style={({isActive}) => isActive ? {...activeStyle, display: "block", textAlign: "center"} : {...idleStyle, display: "block", textAlign: "center"}}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                صفحه اصلی
                            </NavLink>
                            <NavLink 
                                to="/soon" 
                                style={({isActive}) => isActive ? {...activeStyle, display: "block", textAlign: "center"} : {...idleStyle, display: "block", textAlign: "center"}}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                فروشگاه
                            </NavLink>
                            <NavLink 
                                to="/About" 
                                style={({isActive}) => isActive ? {...activeStyle, display: "block", textAlign: "center"} : {...idleStyle, display: "block", textAlign: "center"}}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                درباره ما
                            </NavLink>
                            <NavLink 
                                to="/contact" 
                                style={({isActive}) => isActive ? {...activeStyle, display: "block", textAlign: "center"} : {...idleStyle, display: "block", textAlign: "center"}}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                تماس
                            </NavLink>
                        </nav>
                    </div>
                </div>
            )}

            <header dir="rtl" className="header-wrap">
                {/* Left Section - Logo, Hamburger, and Title */}
                <div className="left-section">
                    {/* Hamburger Menu Button - Only shows on mobile */}
                    <button 
                        className="mobile-menu-btn"
                        onClick={() => setMobileMenuOpen(true)}
                        title="منو"
                    >
                        ☰
                    </button>

                    <Link to="/" className="logo-link">
                        <div className="logo">
                            <img
                                src={logoImg}
                                alt="استودیو مدریک"
                                title="استودیو مدریک"
                                style={{
                                    width: "80%",
                                    height: "80%",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />
                        </div>

                        <div className="title-style">{title}</div>
                    </Link>
                </div>

                {/* Desktop Navigation - Hidden on mobile */}
                <nav className="desktop-nav">
                    <NavLink to="/" style={({isActive}) => isActive ? activeStyle : idleStyle}>صفحه اصلی</NavLink>
                    <NavLink to="/soon" style={({isActive}) => isActive ? activeStyle : idleStyle}>فروشگاه</NavLink>
                    <NavLink to="/About" style={({isActive}) => isActive ? activeStyle : idleStyle}>درباره ما</NavLink>
                    <NavLink to="/contact" style={({isActive}) => isActive ? activeStyle : idleStyle}>تماس</NavLink>
                </nav>

                {/* Icons Section - Always visible */}
                <div className="icons-section">
                    <button title="اکانت من" className="icon-btn" onClick={() => navigate('/soon')}>👤</button>

                    <div style={{position: "relative"}}>
                        <button title="سبد خرید" className="cart-btn" onClick={() => setOpen(v => !v)}>
                            🛒
                            {totalQty > 0 && <span className="badge">{totalQty}</span>}
                        </button>

                        {open && (
                            <div className="cart-panel" onClick={(e) => e.stopPropagation()}>
                                <div className="cart-header">
                                    <b>سبد خرید</b>
                                    <button className="text-btn" onClick={() => setOpen(false)}>✖</button>
                                </div>

                                {items.length === 0 ? (
                                    <div className="empty-cart">سبد شما خالی است</div>
                                ) : (
                                    <>
                                        <div className="cart-list">
                                            {items.map(it => (
                                                <div key={it.id} className="cart-row">
                                                    <img src={it.image}
                                                         alt={it.name}
                                                         style={{
                                                             width: 60,
                                                             height: 40,
                                                             objectFit: "cover",
                                                             borderRadius: 8
                                                         }}/>
                                                    <div style={{flex: 1}}>
                                                        <div style={{fontWeight: 700, fontSize: 13}}>{it.name}</div>
                                                        <div style={{fontSize: 12, color: "#64748b"}}>${it.price}</div>
                                                    </div>
                                                    <div style={{display: "flex", alignItems: "center", gap: 6}}>
                                                        <button onClick={() => changeQty(it.id, -1)} className="qty-btn">−
                                                        </button>
                                                        <span style={{minWidth: 22, textAlign: "center"}}>{it.qty}</span>
                                                        <button onClick={() => changeQty(it.id, +1)} className="qty-btn">＋
                                                        </button>
                                                    </div>
                                                    <button onClick={() => removeFromCart(it.id)} className="remove-btn">حذف
                                                    </button>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="cart-footer">
                                            <div style={{fontWeight: 800}}>
                                                مجموع: <span style={{color: "#059669"}}>${totalPrice.toFixed(2)}</span>
                                            </div>
                                            <div style={{display: "flex", gap: 8, flexWrap: "wrap"}}>
                                                <button className="clear-btn" onClick={clearCart}>خالی کردن</button>
                                                <button className="checkout-btn" onClick={() => navigate('/soon')}>ادامه خرید
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
}
